<template>
    <div>
        <template v-if="company === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Active Companies ({{active_count}})</h1>
                <router-link to="/addCompany" class="btn btn-primary float-right active"> Add New Company</router-link>
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
					<table id="companyTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Payment Engine</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
<!--                                <th>Is Dormant</th>-->
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
				<!-- <div class="tab-pane fade" id="inactive" role="tabpanel" aria-labelledby="inactive-tab">
					<table id="inActivecompanyTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Payment Engine</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div> -->
				
			</div>
        </template>
        <template v-else-if="company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                company: null,
                dtActive : null,
                active_count : 0,
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('company').then(result => {
                this.company = result.company;
            }).then(result => {
                if(this.company == true){
                    this.activeCompanies();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            activeCompanies(){
                this.dtActive = $('#companyTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listCompanies",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": 'records',
                        "data": function ( d ) {
                            d.tab = 'active';
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'payment_engine'},
                        {data: 'phone'},
                        {data: 'email'},
                        {data: 'address_1'},
                        // {
                        //  data: 'is_dormant',
                        //  render: function(data, type, full) {
                        //   return data == 1 ? 'YES' : 'NO';
                        //  }
                        // },
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editCompany/'+full['id'];
                            // var $removeDormantIcon = full['is_dormant'] == 1 ? '<a href="javascript:void(0);" onclick="VueComponents.companiesComponent.methods.unMarkCompanyDormant('+full['id']+')" class="action edit"><i class="fas fa-times"><i class="fas fa-exclamation-triangle "></i></i> </a>' : '';
                            var $dormantIcon = full['is_dormant'] == 0 ? '<a href="javascript:void(0);" onclick="VueComponents.companiesComponent.methods.markCompanyDormant('+full['id']+')" class="action edit"><i class="fas fa-exclamation-triangle"></i></a>' : '';
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a> | <a href="javascript:void(0);" onclick="VueComponents.companiesComponent.methods.deleteCompany('+full['id']+')" class="action edit"><i class="fas fa-trash"></i></a> | '+ $dormantIcon;
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 5 ]
                    }],
                    "initComplete": (settings, json) => { this.active_count = json.recordsTotal; this.$Progress.finish();}
                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        gThat.dtActive.search(this.value).draw();
                    }
                });
            },
           deleteCompany(id){
               var that = this;
               gThat.$Progress.start();
               swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this company !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get("/api/softDeleteCompany/"+id)
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.status == 200){
                                    gThat.$Progress.finish();
                                    gThat.dtActive.ajax.reload( json => {
                                        gThat.active_count = json.recordsTotal;
                                    }, false);
                                    gThat.showAlertBox('success','Company deleted successfully.');
                                }else{
                                    gThat.showToastBox('error','System is not responding! Please try again later.');
                                }
                            }else{
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error','System is not responding! Please try again later.');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error','System is not responding! Please try again later.');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                });
                
           },
          markCompanyDormant(id){
            var that = this;
            gThat.$Progress.start();
            swal.fire({
              title: 'Are you sure?',
              text: "You want to mark this company dormant ?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, mark it dormant!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.value) {
                axios.get("/api/markCompanyDormant/"+id)
                    .then(res => {
                      if(res.status == 200){
                        gThat.showAlertBox('success','Company marked dormant successfully.');
                        gThat.$router.go(gThat.$router.currentRoute);
                      }else{
                        gThat.$Progress.fail();
                        gThat.showAlertBox('error','System is not responding! Please try again later.');
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      gThat.$Progress.fail();
                      gThat.showAlertBox('error','System is not responding! Please try again later.');
                    });
              } else if (result.dismiss === Swal.DismissReason.cancel){
                gThat.$Progress.finish();
                swal.fire(
                    'Cancelled',
                    'Your decision has been cancelled',
                    'error'
                )
              }
            });

          },
          unMarkCompanyDormant(id){
            var that = this;
            gThat.$Progress.start();
            swal.fire({
              title: 'Are you sure?',
              text: "You want to remove this company account dormancy ?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, remove dormancy!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.value) {
                axios.get("/api/unMarkCompanyDormant/"+id)
                    .then(res => {
                      if(res.status == 200){
                        gThat.showAlertBox('success','Company dormancy removed successfully.');
                        gThat.$router.go(gThat.$router.currentRoute);
                      }else{
                        gThat.$Progress.fail();
                        gThat.showAlertBox('error','System is not responding! Please try again later.');
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      gThat.$Progress.fail();
                      gThat.showAlertBox('error','System is not responding! Please try again later.');
                    });
              } else if (result.dismiss === Swal.DismissReason.cancel){
                gThat.$Progress.finish();
                swal.fire(
                    'Cancelled',
                    'Your decision has been cancelled',
                    'error'
                )
              }
            });

          },
        },
    }
</script>
